import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faSearch, faArrowLeft, faArrowRight, faAdd, faSave } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Approval.css'
import { Tooltip } from 'react-tooltip';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import GoCast from '../../Images/GoCast.png'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ApprovalGrid = () => {
    const { approvalID } = useParams();
    // Loading GIF
    const [isLoading, setIsLoading] = useState(false);
    // Navigation To Another Page
    const navigate = useNavigate();
    // Table visibility
    const [tableVisible, setTableVisible] = useState(true);
    // Search-bar
    const [searchOpen, setSearchOpen] = useState(false);

    //        API CODE
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed
    const [showEmptyRow, setShowEmptyRow] = useState(false);
    const [modifiedData, setModifiedData] = useState([]); // New state for modified data
    const [modifiedRows, setModifiedRows] = useState(new Set()); // New state to track modified rows

    const [codeTypeID, setcodeTypeID] = useState('');
    const [description, setDescription] = useState('');
    const [fullDescription, setFullDescription] = useState('');
    const [createDate, setCreateDate] = useState('');
    const [autoSequence, setAutoSequence] = useState(false);
    const [sequence, setSequence] = useState('');

    const fetchData = async () => {
        setIsLoading(true); // Loading GIF
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UserCodesSvc/UserCodes'; // Adjust the URL as needed

        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData(data.value);
                setIsLoading(false); // Loading GIF
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }

        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []); // Fetch data on component mount


    const saveData = async () => {
        setIsLoading(true); // Loading GIF
        const username = 'manager';
        const password = 'manager';
        // const apiUrl = `https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UserCodesSvc/UserCodes(PRECAST,${approvalID})`;

        if (showEmptyRow) {
            const apiUrl = `https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UserCodesSvc/UserCodes`;
            console.log(autoSequence)
            if (autoSequence === "on") {
                console.log("dakhal")
                setAutoSequence(true)
            }
            else {
                console.log("madakhalsh")
            }
            console.log(autoSequence)
            const newRow = {
                "Company": "PRECAST",
                "CodeTypeID": codeTypeID,
                "CodeTypeDesc": description,
                "LongDesc": fullDescription,
                // CreateDate: createDate,
                "CreateUser": "MANAGER",
                "AutoSequence": autoSequence,
                "SequenceID": sequence
            };
            console.log(newRow)
            try {
                const response = await axios.post(apiUrl, newRow, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                setShowEmptyRow(false)
                console.log('Data saved successfully:', response.data);
                setIsLoading(false); // Loading GIF
                // Toast Notifcation
                setTimeout(() => {
                    toast.success("Data Saved Successfully");
                }, 10);
            } catch (error) {
                console.error('Error:', error.message);
                setIsLoading(false); // Loading GIF
                // Toast Notifcation
                setTimeout(() => {
                    toast.error("Failed To Save");
                }, 10);
            }

        }
        else {
            const apiUrl = `https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UserCodesSvc/UserCodes(PRECAST,${approvalID})`;
            try {
                const response = await axios.patch(apiUrl, modifiedData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                console.log('Data saved successfully:', response.data);
                setIsLoading(false); // Loading GIF
                // Toast Notifcation
                setTimeout(() => {
                    toast.success("Data Saved Successfully");
                }, 10);
            } catch (error) {
                console.error('Error:', error.message);
                setIsLoading(false); // Loading GIF
                // Toast Notifcation
                setTimeout(() => {
                    toast.error("Failed To Save");
                }, 10);
            }
        }

    };


    const handleInputChange = (e, index, field) => {
        const newValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const newData = [...modifiedData];
        newData[index][field] = newValue;
        setModifiedData(newData);
        setModifiedRows(new Set(modifiedRows.add(index))); // Add the index to modifiedRows set
    };


    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = apiData.slice(startIndex, endIndex);

        // Check if there are any empty rows
        const emptyRowExists = currentItems.some(item => Object.values(item).some(value => value === ''));

        return (
            <>
                {currentItems.map((item, index) => (
                    <tr key={index}>
                        <td className='blue-hyper' onClick={() => navigate(`/approval/approvalform/${item.CodeTypeID}`)}>{item.CodeTypeID}</td>
                        <td>{item.CodeTypeDesc}</td>
                        <td>{item.LongDesc}</td>
                        <td>{new Date(item.CreateDate).toLocaleDateString('en-US')}</td>
                        <td>{item.CreateUser}</td>
                        <td>
                            <input
                                type="checkbox"
                                checked={item.AutoSequence ? 'true' : ''}
                            />
                        </td>
                        <td>{item.SequenceID}</td>
                    </tr>
                ))}
                {/* Add input fields for the empty row */}
                {showEmptyRow && (
                    modifiedData.slice(startIndex, endIndex).map((item, index) => (
                        <tr key={`empty-row-${index}`}>
                            <td><input type="text" placeholder="Code Type ID" value={codeTypeID} onChange={(e) => setcodeTypeID(e.target.value)} /></td>
                            <td><input type="text" placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)} /></td>
                            <td><input type="text" placeholder="Full Description" value={fullDescription} onChange={(e) => setFullDescription(e.target.value)} /></td>
                            <td><input type="text" placeholder="Create Date" value={createDate} onChange={(e) => setCreateDate(e.target.value)} /></td>
                            <td><input type="text" placeholder="Created By" /></td>
                            <td><input type="checkbox" checked={autoSequence} onChange={(e) => setAutoSequence(e.target.value)} /></td>
                            <td><input type="text" placeholder="Sequence" value={sequence} onChange={(e) => setSequence(e.target.value)} /></td>
                        </tr>
                    ))
                )}
            </>
        );
    };

    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Search Toggle
    const toggleSearch = () => {
        setSearchOpen(!searchOpen);
    }
    // Toggle table visibility
    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    }

    const addNewRow = () => {
        console.log("Add button clicked!");
        // Create a new row with default values or with values based on your requirements
        const newRow = {
            CodeTypeID: '',
            CodeTypeDesc: '',
            LongDesc: '',
            CreateDate: '',
            CreateUser: '',
            AutoSequence: false,
            SequenceID: ''
        };
        setShowEmptyRow(true);
        // Add the new row to the modifiedData state
        setModifiedData([...modifiedData, newRow]);
        // Also, update the apiData state if needed
        setApiData([...apiData, newRow]);
    };

    return (
        <div className='card ApprovalTable'>
            <ToastContainer />
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className="card-header-hold">
                {/* <button type="button" className="toggle-table-icon" onClick={toggleTableVisibility}>
                    <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
                </button> */}
                {/* <h2 className='panel-title-approval'>Approval Setup</h2> */}
                <div className='ctrl-btns-approval'>
                    <button className="btn" id='add' onClick={addNewRow}>
                        <FontAwesomeIcon icon={faAdd} />
                    </button>

                    <Tooltip
                        anchorSelect="#add"
                        content="Add"
                        place='bottom'
                    />
                    <button className="btn" id='save' onClick={saveData}>
                        <FontAwesomeIcon icon={faSave} />
                    </button>
                    <Tooltip
                        anchorSelect="#save"
                        content="Save"
                        place='bottom'
                    />
                    {/* Existing search div */}
                </div>
            </div>
            {/* Conditionally render the table */}
            {tableVisible && (
                <div className="card-body">
                    <div class="table-responsive">
                        <div className="scrollable-table-body">
                            <table className="table table-bordered-AP">
                                {/* Table content */}
                                <thead className='table-primary'>
                                    <tr className='bg-primary text-white'>
                                        <th>Code Type ID</th>
                                        <th>Description</th>
                                        <th>Full Description</th>
                                        <th>Create Date</th>
                                        <th>Created By</th>
                                        <th>AutoSequence</th>
                                        <th>Sequence</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderTableRows()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="pagination">
                        <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                        <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ApprovalGrid;